// components/EventCard.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin, Clock, Plus } from "lucide-react";
import { Button } from "../../../ui/Button/Button.jsx";

const EventCard = ({ event, onAdd, isAdded }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    // Show loader immediately
    setLoading(true);
    // Trigger removal of this card (the parent will update state)
    onAdd(event);
  };

  return (
    <motion.div
      layout
      className="w-[220px] h-[80px] shrink-0 relative group"
      initial={{ scaleX: 1, opacity: 1 }}
      exit={{
        scaleX: 0,
        opacity: 0,
        transition: { duration: 0.5, ease: "easeInOut" },
      }}
      style={{ originX: 0 }} // ensures the card shrinks from the left edge
    >
      <div
        className={`absolute inset-0 rounded-full ${event.color} shadow-md transition-all duration-300 group-hover:scale-105 flex items-center bg-gradient-to-br from-red-50 to-gray-100`}
      >
        <div className="absolute left-4 w-12 h-12 rounded-full bg-white flex items-center justify-center">
          <Button
            className="absolute bg-grey-500 text-red-500 rounded-full h-12 w-12 flex items-center justify-center hover:text-red-600 transform hover:scale-110"
            onClick={handleClick}
            disabled={isAdded || loading}
            variant="custom"
            size="none"
          >
            {loading ? (
              // Red spinner using Tailwind CSS classes.
              <div className="w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full animate-spin" />
            ) : (
              <Plus className="w-4 h-4" />
            )}
          </Button>
        </div>
        <div className="ml-20 flex-grow">
          <h3 className="text-xs font-semibold mb-1">{event.eventName}</h3>
          <p className="text-xs text-gray-600">
            {new Date(event.eventDate).toDateString()}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default EventCard;
